import { Component, OnInit } from "@angular/core";
import { ChartConfiguration, ChartOptions } from "chart.js";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { MonthlyBalanceIndicatorData } from "src/app/ui/models/domains/pbm/indicators/monthly-balance-data";
import { MonthlyBalanceIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";

@Component({
  selector: "company-balance",
  templateUrl: "./company-balance.component.html",
  styleUrls: ["./company-balance.component.scss"],
})
export class CompanyBalanceComponent implements OnInit {
  lineChartData: ChartConfiguration<"line">["data"];
  public lineChartLabels: string[] = [""];
  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          display: true,
        },
        ticks: {
          color: "#090f34",
          font: {
            size: 11,
          },
        },
      },
      y: {
        beginAtZero: true,
        position: "left",
        ticks: {
          padding: 35,
          color: "#090f34",
          stepSize: 300000,
          font: {
            size: 11,
          },
        },
      },
    },
    plugins: {
      legend: { display: false },
      datalabels: {
        display: false, // Remove os valores dos pontos
        font: {
          size: 11,
        },
        anchor: "center",
        align: "top",
        color: "#000000",

        borderRadius: 10,
        formatter: function (value) {
          return `R$ ${value.toLocaleString("pt-BR")}`;
        },
      },
    },
  };
  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) {}

  async ngOnInit() {
    const monthlyBalanceIndicatorData = (await this.indicatorMediator.getIndicatorData(
      new MonthlyBalanceIndicatorDataStrategy(),
    )) as MonthlyBalanceIndicatorData;
    this.setMonths(monthlyBalanceIndicatorData.getMonths());
    this.setChartData(monthlyBalanceIndicatorData.getValues());
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) await this.buildChart([company.getFiscalNumber()]);
    else await this.buildChart();
    this.isLoading = false;
  }

  public setMonths(months: Array<string>): void {
    this.lineChartLabels = months;
  }

  public async buildChart(fiscalNumber: Array<string> = null): Promise<void> {
    const monthlyBalanceIndicatorData = await this.indicatorService.getMonthlyBalance(fiscalNumber);
    this.setMonths(monthlyBalanceIndicatorData.getMonths());
    this.setChartData(monthlyBalanceIndicatorData.getValues());
  }

  public async setChartData(values: Array<number>): Promise<void> {
    const lineChartDataSets = [
      {
        label: "R$",
        data: values,
        backgroundColor: "rgba(33, 42, 86, 0.3)",
        borderColor: "#1B55E2",
        pointBackgroundColor: "#1B55E2",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#1B55E2",
        pointHoverBorderColor: "#fff",
        fill: true,
      },
    ];
    this.lineChartData = {
      labels: this.lineChartLabels,
      datasets: lineChartDataSets,
    };
  }
}
